export { default } from './visuallyHidden';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/visuallyHidden/index.js
// module id = 755
// module chunks = 22